// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import classnames from 'classnames';

// Components
import Pagination from '../core/pagination';

// Contexts
import {SearchContext} from '../../contexts/search-context';

function SearchPagination({className, inline, maxPages = 9, maxResults, query, totalPages = 0}) {
    const getClass = () =>
        classnames(
            {
                'services-search-pagination': true,
            },
            className
        );

    const getMaxResultPages = () => {
        const pageLimit = get(query, 'pageLimit', 20);

        return maxResults && pageLimit ? Math.floor(maxResults / pageLimit) : 0;
    };

    const getPaginationProps = () => ({
        className: getClass(),
        currentPage: get(query, 'page', 0),
        inline,
        maxPages,
        maxResultPages: getMaxResultPages(),
        totalPages,
    });

    return (
        <SearchContext.Consumer>
            {({setQuery}) => (
                <Pagination
                    {...getPaginationProps()}
                    onClick={(pageNumber) => {
                        setQuery({page: pageNumber});
                    }}
                />
            )}
        </SearchContext.Consumer>
    );
}

SearchPagination.propTypes = {
    className: PropTypes.string,
    inline: PropTypes.bool,
    maxPages: PropTypes.number,
    maxResults: PropTypes.number,
    query: PropTypes.object,
    totalPages: PropTypes.number,
};

export default SearchPagination;
